export abstract class OnboardingDao {
  public abstract findAllTrackings(): Promise<string[]>
  public abstract createOnboardingTracking(onboardingHintSeriesKey: string): Promise<string[]>
  public abstract deleteByKey(key: string): Promise<void>
  public abstract deleteAll(): Promise<void>
}
